import { gql } from '@apollo/client'

export const ROOMTYPES_QUERY = gql`
  query RoomTypes(
    $propertyCode: String!
    $showDeletedRoomTypes: Boolean!
    $showDeactivedRoomTypes: Boolean!
    $providerCode: String
    $showLog: Boolean
  ) {
    roomTypes(
      propertyCode: $propertyCode
      showDeletedRoomTypes: $showDeletedRoomTypes
      showDeactivedRoomTypes: $showDeactivedRoomTypes
      providerCode: $providerCode
      showLog: $showLog
    ) {
      id
      name
      roomTypeCode
      displayRoomTypeCode
      defaultOccupancy
      maxOccupancy
      roomCount
      type
      deleted
      active
      parentRoomTypeCode
    }
  }
`

export const ROOMTYPE_QUERY = gql`
  query RoomType(
    $propertyCode: String
    $roomTypeCode: String
    $accommodationId: String
    $roomTypeId: String
  ) {
    roomType(
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
      accommodationId: $accommodationId
      roomTypeId: $roomTypeId
    ) {
      basicDetails {
        name
        nameTranslatedList {
          value
          label
          nativeLabel
        }
        roomTypeCode
        displayRoomTypeCode
        defaultRackRate
        description
        descriptionTranslatedList {
          value
          label
          nativeLabel
        }
        roomTypeID
        type
        active
        deleted
      }
      inventoryAndBooking {
        maxOccupancy
        defaultOccupancy
        numberOfRooms
      }
      virtualRoomDetails {
        parentRoomTypeCode
        virtualRoomAvailabilityMultiplier
      }
    }
  }
`

export const ROOMTYPE_NAME_QUERY = gql`
  query RoomTypeName(
    $propertyCode: String
    $roomTypeCode: String
    $accommodationId: String
    $roomTypeId: String
  ) {
    roomTypeName(
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
      accommodationId: $accommodationId
      roomTypeId: $roomTypeId
    ) {
      name
    }
  }
`
